import { render, staticRenderFns } from "./PerformanceDashboard.vue?vue&type=template&id=aa78e552"
import script from "./PerformanceDashboard.vue?vue&type=script&lang=js"
export * from "./PerformanceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports